

import http from '@/services/http'

export const SET_LIST_COMP_TABSS = 'setListCompTabs'
export const SET_LIST_PLANILHA = 'setListPlanilha'

export const SET_PLANILHA = 'setPlanilha'

export const SET_COMP_TAB = 'setCompTab'
export const SET_FATURAMENTO = 'setCliFaturamento'
export const SET_COMP_TABS_NEW = 'setAtividadeNew'

export const SET_MESSAGE_ALERT = 'setMessage'
const actions = {


    async listar_comp_tabs(context) {
        await http.get('planilha-contabilidade')
            .then(response => context.commit(SET_LIST_COMP_TABSS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async listar_planilha(context, value) {
       await http.get(value.rota, {
            params: value.filtros
          })
            .then(response => {
                // context.commit(SET_PLANILHA, response.data)
                context.commit(SET_LIST_PLANILHA, response.data)
            })
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async carregar_planilha(context, value) {
        let message = await http.post('planilha-contabilidade/' + value.tabelas_id, value)
        .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_COMP_TABS_NEW, message.message.conteudo)

    },


    async create_comp_tabs(context, value) {
        let message = await http.post('planilha-contabilidade', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_COMP_TABS_NEW, message.message.conteudo)
        console.log(message.message)


    },


    async update_planilha(context, value) {
        let message = await http.put('planilha-contabilidade/'+ value.id , value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)


    },
    async update_comp_tabs(context, value) {
        let data = await http.put('planilha-contabilidade/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
    },

    async delete_comp_tabs(context, value) {
        let data = await http.delete('planilha-contabilidade/' + value.id)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
    },



    set_comp_tabs(context, value) {
        context.commit(SET_COMP_TAB, value)

    },
    set_planila(context, value) {
        context.commit(SET_PLANILHA, value)

    },






};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
    [SET_LIST_COMP_TABSS](state, value) {
        state.lista_comp_tabs = value
    },
    [SET_LIST_PLANILHA](state, value) {
        state.lista_planilha = value

    },
    [SET_PLANILHA](state, value) {
        state.planilha_fixa = value
    },
    [SET_COMP_TAB](state, value) {
        state.comp_tab = value
    },
    [SET_COMP_TABS_NEW](state, value) {
        state.lista_comp_tabs.push(value)
    },

    [SET_FATURAMENTO](state, value) {
        state.faturamento = value
    },


};
const getters = {

}

const state = {
    mensagem_alert: [],
    lista_comp_tabs: [],
    lista_planilha: {data:[],
        pagination:{
            current_page: 1,
            last_page: 1,
            per_page: 1,
            total: 1
        }},
    comp_tab: [],
    faturamento: 0,
    planilha_fixa:[]
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};


